import { useFetch } from '@/shared/hooks/useFetch';
import { queryKeys } from '@/shared/api/queryKeys';
import { apiParcelsAvailableForPhotoVideo } from '@/entities/parcels/modules/api/parcels';

export const useParcelsAvailableForPhotoVideo = (type: 'PHOTO' | 'VIDEO' | 'PROVERKA') =>
  useFetch({
    api: () => apiParcelsAvailableForPhotoVideo(type),
    keywords: queryKeys.parcels.availableForPhotoVideo(type),
    staleTime: 60_000,
  });
